<template>
    <div class="vehicle">
        <label class="vehicle-description" :for="name">
            <span class="vehicle-description-label">{{ vehicleLabel }}</span>
            {{ vehicle.Description }}
        </label>
        <TextboxField
            v-model="vehicle.LicensePlate"
            :name="name"
            :input="{
                label: t({ key: 'checkout.license_plate' }),
                id: name,
            }" />
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent, PropType } from 'vue';
    import { t } from '@shared/helpers/translation';
    import { FerryVehicle } from '@shared/interfaces/ferry';
    import TextboxField from '@ui/components/FormV2/Fields/Textbox/TextboxField.vue';

    export default defineComponent({
        name: 'FerryVehicle',
        components: { TextboxField },
        methods: { t },
        props: {
            vehicle: {
                type: Object as PropType<FerryVehicle>,
                required: true,
            },
            name: {
                type: String,
                required: true,
            },
            vehicleNumber: {
                type: Number,
                required: true,
            },
        },
        setup(props) {
            const vehicleLabel = computed(() => {
                const { vehicleNumber } = props;
                const vehicleText = t({ key: 'shared.vehicle' });
                return `${vehicleText} ${vehicleNumber}:`;
            });

            return { vehicleLabel };
        },
    });
</script>

<style lang="scss" scoped>
    @forward './Vehicle.scss';
</style>
